import { reatomAsync, withDataAtom } from "@reatom/async";
import { API } from "src/api";
import { withIsLoadingAtom } from "src/common/pipes";

export const getCertInfo = reatomAsync(async (_ctx, certNo: string) => {
  return await API.poizonPublicApi
    .dewuControllerGetCertInfo(certNo)
    .then((res) => res.data);
}, "getCertInfo").pipe(withDataAtom(null), withIsLoadingAtom());
